import { useState, useEffect } from "react";
import { getToken } from "../../helpers";
import Loading from "./Loading";
import { useFetchAPIContext } from "../../context/FetchAPIContext";

const useFetchAPI = (url) => {
  // const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const {data, isLoading, setApiUrl} = useFetchAPIContext();

   const handleUrl = () => {
    setApiUrl(url);
    };
    handleUrl();

  
  // try {
  //   const response = fetch(url, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       // set the auth token to the user's jwt
  //       Authorization: `Bearer: ${getToken()}`,
  //     },
  //   });
  //   const x= response.json()
  //   if(response != null){
  //     setData(x);
  //     setLoading(false);
  //   }
  // } catch (error) {
  //   return error
  // } finally {
  //   setLoading(false);
  // }

  // useEffect(() => {
  //   fetch(url, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer: ${getToken()}`,
  //         },
  //       })
  //     .then((res) => {
  //       if(res.ok)
  //         return res.json();
  //       else
  //         throw new Error(res.statusText);
  //     })
  //     .then((data) => {
  //       if(data != null){
  //       setData(data);
  //       setLoading(false);
  //       }
  //     })
  //     .catch((error)=>error);
      
  // }, [url]);

  return data;
 
};

export default useFetchAPI;